import * as htmlToImage from "html-to-image"
import { useCallback } from "react"

const applyComputedStyles = (element: HTMLElement) => {
  const textElements = element.querySelectorAll("text, path")
  textElements.forEach((textElement) => {
    if (textElement instanceof SVGElement) {
      // Check if the element has inline styles
      if (textElement.style && textElement.style.length > 0) {
        // Iterate over existing inline styles
        for (let i = 0; i < textElement.style.length; i++) {
          const property = textElement.style[i]
          const computedStyle = window.getComputedStyle(textElement)
          const computedValue = computedStyle.getPropertyValue(property)
          if (computedValue) {
            textElement.style.setProperty(property, computedValue)
          }
        }
      }

      // Handle path elements specifically for stroke attribute
      if (textElement.tagName.toLowerCase() === "path") {
        const computedStyle = window.getComputedStyle(textElement)
        const strokeValue = computedStyle.getPropertyValue("stroke")
        if (strokeValue) {
          textElement.setAttribute("stroke", strokeValue)
        }
      }
    }
  })

  // Process child elements recursively
  Array.from(element.children).forEach((child) => {
    if (child instanceof HTMLElement) {
      applyComputedStyles(child)
    }
  })
}

export const useCopyElementRefAsImage = (
  elementRef: React.RefObject<HTMLElement>
) => {
  return useCallback(async () => {
    if (!elementRef.current) return
    applyComputedStyles(elementRef.current)

    const blob = await htmlToImage.toBlob(elementRef.current, {
      pixelRatio: 3,
      backgroundColor: "transparent",
    })
    if (!blob) return

    navigator.clipboard.write([
      new ClipboardItem({
        [blob.type]: blob,
      }),
    ])

    return blob
  }, [elementRef])
}

export const useSaveElementRefAsImage = (
  elementRef: React.RefObject<HTMLElement>
) => {
  return useCallback(async () => {
    if (!elementRef.current) return
    applyComputedStyles(elementRef.current)

    const blob = await htmlToImage.toBlob(elementRef.current, {
      pixelRatio: 3,
      backgroundColor: "transparent",
    })
    if (!blob) return

    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `download.png`
    a.click()

    URL.revokeObjectURL(url)

    return blob
  }, [elementRef])
}
